export const OLD_APP_URL =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:3000";

export const OLD_APP_HOME_URL = `${OLD_APP_URL}/home`;
export const OLD_APP_LOGIN_URL = `${OLD_APP_URL}/login`;
export const OLD_APP_LOGOUT_URL = `${OLD_APP_URL}/logout`;

export const RESOURCE_GROUPS = [
  {
    label: "Genie Brands",
    items: [
      {
        label: "Vendor search",
        url: "/vendors"
      },
      {
        label: "Brands",
        url: "/brands"
      },
      {
        label: "Vendor Remappings",
        url: "/vendor-revendorizations"
      },
      {
        label: "Brand attributes",
        url: "/brandAttributes"
      },
      {
        label: "Product types",
        url: "/genie/producttypes"
      },
      {
        label: "Genie brand data",
        url: "/genie"
      },
      {
        label: "Brand Rating Rubrics",
        url: "/brand-rating-rubrics"
      },
      {
        label: "Products",
        url: "/products"
      }
    ]
  },
  {
    label: "Content",
    items: [
      {
        label: "App articles",
        url: "/articles"
      },

      {
        label: "Search Collections",
        url: "/genie/collections"
      }
    ]
  },
  {
    label: "Users",
    items: [
      {
        label: "Polls",
        url: "/polls"
      },
      {
        label: "Collective Challenges",
        url: "/collectivechallenges"
      },
      {
        label: "Community Reviews",
        url: "/community-reviews"
      },
      {
        label: "Personal Challenges",
        url: "/spendingGoals"
      },
      {
        label: "Watchlists",
        url: "/canonical-aggregations"
      },
      {
        label: "Support Dashboard",
        url: "/support"
      }
    ]
  },
  {
    label: "Utility",
    items: [
      {
        label: "CSV Uploader",
        url: "/uploaders"
      },
      {
        label: "Ingredient Glossary",
        url: "/ingredientGlossary"
      },
      {
        label: "Ingredient Checker",
        url: "/checker"
      },
      {
        label: "Image+",
        url: "/images"
      },
      {
        label: "Job Monitor",
        url: "/job-monitor"
      },
      {
        label: "Feature Flags",
        url: "/feature-flags"
      },
      {
        label: "Carbonizer",
        url: "/carbon"
      },
      {
        label: "Carbonizer Management",
        url: "/carbonizer",
        external: true
      },
      {
        label: "Carbon Offset Management",
        url: "/carbon_offset_management"
      }
    ]
  }
];
